import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
  FormInput,
  notification,
  Form, Col, FormResetButton
} from '@digital/ui';
import {
  ResumoContratado,
  getAllContratadoMaterialProjetoByNumeroOi,
  ContratadoRequisicaoCompraMaterial,
  ContratadoRequisicaoCompraServico,
  getAllContratadoServicoProjetoByNumeroOi,
  getAllContratadoTipoOverHeadByNumeroOi,
  ContratadoOverHeadAnual,
  getAllResumoContratadoProjeto,
} from '@app/api/projeto';
import { Collapse, Icon } from 'antd';
import FormTableContratadoRequisicaoCompraMaterial from './FormTableContratadoRequisicaoCompraMaterial';
import FormTableContratadoRequisicaoCompraServico from './FormTableContratadoRequisicaoCompraServico';
import FormTableContratadoOverheadAnual from './FormTableContratadoOverheadAnual';

interface FormResumoContratadoProps {
  projetoId: string,
}

const { Panel } = Collapse;

const FormTableResumoContratado = (props: FormResumoContratadoProps) => {
  const {
    projetoId
  } = props;

  const [resumoContratado, setResumoContratado] = useState<ResumoContratado[]>();
  const [contratadoMaterial, setContratadoMaterial] = useState<ContratadoRequisicaoCompraMaterial[]>();
  const [contratadoServico, setContratadoServico] = useState<ContratadoRequisicaoCompraServico[]>();
  const [valorTotal, setValorTotal] = useState<string>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [ordemInvestimentoId, setOrdemInvestimentoId] = useState<string>();
  const [displayWidgetContratado, setDisplayWidgetContratado] = useState({ display: 'none' });
  const [contratadoOverHeadAnual, setContratadoOverHeadAnual] = useState<ContratadoOverHeadAnual>();

  const handleTabelaContratadoMaterial = (result: ContratadoRequisicaoCompraMaterial[]) => {
    setContratadoMaterial([]);
    if (result && result.length > 0) {
      setContratadoMaterial(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
      setContratadoMaterial([]);
    }
  };

  const handleTabelaContratadoServico = (result: ContratadoRequisicaoCompraServico[]) => {
    setContratadoServico([]);
    if (result && result.length > 0) {
      setContratadoServico(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
      setContratadoServico([]);
    }
  };

  const handleTabelaContratadoTipoOverHead = (result: any) => {
    setContratadoOverHeadAnual({} as ContratadoOverHeadAnual);
    if (result) {
      setContratadoOverHeadAnual(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
    }
  };

  const getResumoContratado = async () => {
    setContratadoMaterial([]);
    setContratadoServico([]);
    const result = await getAllResumoContratadoProjeto(projetoId);
    if (result) {
      setResumoContratado(result);
    }
  };

  useEffect(() => {
    if (resumoContratado && resumoContratado.length > 0) {
      var requisitado = resumoContratado[resumoContratado.length - 1];
      if (requisitado) {
        setValorTotal(requisitado.valorTotalFormatado);
      }
    }
  }, [resumoContratado]);

  useEffect(() => {
    getResumoContratado();
    setDisplayWidgetContratado({ display: 'none' });
  }, [])

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      var obj = selectedRows[0];
      if (selectedRows) {
        setOrdemInvestimentoId(obj.numero);
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio',
  };

  const verRequisitado = () => {
    if (ordemInvestimentoId) {
      const getContratadoMaterial = async (id: string) => {
        const result = await getAllContratadoMaterialProjetoByNumeroOi(id);
        if (result) {
          handleTabelaContratadoMaterial(result);
        }
      };

      const getContratadoServico = async (id: string) => {
        const result = await getAllContratadoServicoProjetoByNumeroOi(id);
        if (result) {
          handleTabelaContratadoServico(result);
        }
      };

      const getContratadoTipoOverHead = async (id: string) => {
        const result = await getAllContratadoTipoOverHeadByNumeroOi(id);
        if (result) {
          handleTabelaContratadoTipoOverHead(result);
        }
      };

      getContratadoMaterial(ordemInvestimentoId);
      getContratadoServico(ordemInvestimentoId);
      getContratadoTipoOverHead(ordemInvestimentoId);
    } else {
      notification.error('Você deve selecionar um item');
    }
  };

  const atualizaContratadoTipoOverHead = (id: any) => {
    const getContratadoOverhead = async (id: string) => {
      const result = await getAllContratadoTipoOverHeadByNumeroOi(id);
      if (result) {
        setContratadoOverHeadAnual(result);
      }
    };

    const getResumoContratado = async (id: any) => {
      const result = await getAllResumoContratadoProjeto(id);
      if (result && result.length > 0) {
        setResumoContratado(result);
      }
    };

    if (id) {
      getContratadoOverhead(id);
    }
    if (projetoId) {
      getResumoContratado(projetoId);
    }
  };

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'numero',
        width: '2%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="numero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.numero !== undefined &&
          record.numero
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Código do Pacote"
                name="codigoPacote"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.codigoPacote !== undefined &&
          record.codigoPacote
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Nome"
                name="codigoPacote"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.nome !== undefined &&
          record.nome
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Overhead total',
        dataIndex: 'valorTotalTipoOverHeadFormatado',
        width: '35%',
      },
      {
        title: 'Status Contratado',
        dataIndex: 'status',
        width: '35%',
      },
      {
        title: 'Valor Contratado',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'contratoCompraValorTotalFormatado',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<ResumoContratado>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo Contratado" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                resumoContratado && resumoContratado.length > 0 && (
                  <Button
                    type="primary"
                    title="VER CONTRATADO"
                    icon="data-database"
                    onClick={() => {
                      verRequisitado();
                    }}
                  />
                ),
              ]}>
              <Row>
                <Table
                  rowKey="index"
                  columns={customColumns()}
                  dataSource={resumoContratado || []}
                  rowSelection={{
                    ...rowSelection,
                  }}
                  pagination={
                    {
                      pageSize: 5,
                    }
                  }
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>


      <FormTableContratadoRequisicaoCompraMaterial
        contratadoRequisicaoCompraMaterial={contratadoMaterial || []}
        style={displayWidgetContratado}
      />
      <FormTableContratadoRequisicaoCompraServico
        contratadoRequisicaoCompraServico={contratadoServico || []}
        style={displayWidgetContratado}
      />
      <FormTableContratadoOverheadAnual
        contratadoOverHeadAnual={contratadoOverHeadAnual || ({} as ContratadoOverHeadAnual)}
        style={displayWidgetContratado}
        atualizaContratadoTipoOverHead={atualizaContratadoTipoOverHead}
      />
    </>



  );
};

export default FormTableResumoContratado;
